import { render, staticRenderFns } from "./page29.vue?vue&type=template&id=2b8c0871&scoped=true&"
import script from "./page29.vue?vue&type=script&lang=js&"
export * from "./page29.vue?vue&type=script&lang=js&"
import style0 from "./page29.vue?vue&type=style&index=0&id=2b8c0871&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8c0871",
  null
  
)

export default component.exports